import { css } from '@emotion/react';
import { Box, Typography } from '@mui/material';
import { useAtomValue } from 'jotai';
import { useMemo } from 'react';
import { AppName } from '../../../data-models/integrations-app.data-model';
import { fundStrategiesAtom, selectableFundsAtom } from '../../../services/state/AppConfigStateJ';
import { integrationsStateLoadable } from '../../Integrations/state/IntegrationsState';
import { fundComparator } from '../../PortfolioOverview/state/FundFilterStateJ';
import { ConfigRowFieldWrapperClass } from '../Common/ConfigItemRow';
import { GenericConfigPage } from '../Common/GenericConfigPage';
import { getFundFields } from './FundFields';
import { SortFunds } from './FundSort';

const FundRowStyles = css`
  & .${ConfigRowFieldWrapperClass} {
    display: grid;
    grid-template-columns: 14rem 14rem repeat(auto-fit, 8rem);
  }
`;

export function ConfigFund() {
  const funds = useAtomValue(selectableFundsAtom);
  const integrationsLoadable = useAtomValue(integrationsStateLoadable);
  const sortedFunds = useMemo(() => {
    return [...funds].sort(fundComparator);
  }, [funds]);
  const strategyOptions = useAtomValue(fundStrategiesAtom);
  const cartaV2 = useMemo(() => {
    const integrations = integrationsLoadable.state === 'hasData' ? integrationsLoadable.data : undefined;
    return integrations?.find((app) => app.appName === AppName.Carta)?.cartaV2 === true;
  }, [integrationsLoadable]);

  return (
    <Box css={FundRowStyles} width={'100%'}>
      <GenericConfigPage
        baseTitle={'Fund'}
        data={sortedFunds}
        defaultViewMode='grid'
        deleteConfirmation={(fund) => ({
          title: `Delete Fund "${fund.name}"?`,
          confirmLabel: 'Yes, Delete Fund',
          body: (
            <Typography variant='body2' color='text.secondary'>
              Deleting this fund will permanently remove it and all of its related data from the system.
            </Typography>
          ),
        })}
        fields={[]}
        formFields={getFundFields({ cartaManaged: cartaV2, strategyOptions })}
        pageTitle={'Funds'}
        queryURL={'/fund'}
        customToolbarElem={
          <Box display={'flex'} columnGap={'.25rem'}>
            <SortFunds />
          </Box>
        }
      />
    </Box>
  );
}
